import React, { useState } from "react";
import { faMagnifyingGlass, faMultiply, faTableCellsLarge } from "@fortawesome/pro-regular-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CdmVideoWallDest } from "userful-chronos-app-common-js/dist/models/cdm/CdmVideoWall";
import { StringID, isIDNotSet } from "userful-chronos-app-common-js/dist/models/common";
import VideoWallWidget from "../../../Widgets/VideoWall/VideoWallWidget";
import { useTranslation } from "react-i18next";
import UserfulTooltip from "../../../Widgets/UserfulTooltip";
import { useMappingSelector } from "userful-chronos-common-store/dist/mapping";

interface IProps {
    item: CdmVideoWallDest;
    itemID: StringID;
    onDelete?: Function;
    handleMouseEnter?: Function;
    handleMouseLeave?: Function;
    inUse?: string;
}

export default function DestinationVideoWall(props: IProps) {
    const { t } = useTranslation();

    const handleMouseEnter = () => {
        props.handleMouseEnter(true);
    };

    const handleMouseLeave = () => {
        props.handleMouseLeave(false);
    };

    const showingIDs = useMappingSelector((state) => state.uclientsStore.showIDDisplays);
    const seats = props.item.displays.map((d) => d.endPoint.id.seatID).filter((s) => !isIDNotSet(s));
    const isNotShowingID = seats.findIndex((s) => showingIDs.findIndex((c) => c.value === s.value) < 0) >= 0;

    return (
        <>
            <div className="infoBar">
                <div className="infoBarElements">
                    <UserfulTooltip placement="top" title={t("Sources&Destinations.Destinations.videoWallDestination")}>
                        <div className="greenInfo">
                            <FontAwesomeIcon icon={faTableCellsLarge} />
                        </div>
                    </UserfulTooltip>
                    {props.inUse && (
                        <UserfulTooltip placement="top" title={t("Shared.inUse")}>
                            <div className="yellowInfo">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                            </div>
                        </UserfulTooltip>
                    )}
                    {!isNotShowingID && (
                        <UserfulTooltip placement="top" title={t("CommonUI.showingID")}>
                            <div className="greyInfo">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                        </UserfulTooltip>
                    )}
                </div>
                {props.onDelete && (
                    <div className="infoBarActions">
                        <UserfulTooltip title={t("CommonUI.MappingGroups.removeDestination")}>
                            <div className="cardButtons" onClick={() => props.onDelete()}>
                                <FontAwesomeIcon icon={faMultiply} />
                            </div>
                        </UserfulTooltip>
                    </div>
                )}
            </div>
            {props.item.name.length > 14 ? (
                <UserfulTooltip placement="top" title={props.item.name}>
                    <div className="nameBar" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <div className="nameBarText">{props.item.name}</div>
                    </div>
                </UserfulTooltip>
            ) : (
                <div className="nameBar" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <div className="nameBarText">{props.item.name}</div>
                </div>
            )}
            <div className="contentBar">
                <VideoWallWidget videoWall={props.item} maxWidth={134} maxHeight={48} />
            </div>
        </>
    );
}
